import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export enum GTMEvent {
    FLAT_CONFIG = "flat_config",
    FLAT_CONFIG_CHANGE = "flat_config_change",
    FLAT_CONFIG_MORE = "flat_config_more",
    FLAT_CONFIG_OFFER_CLICK = "flat_config_offer_click",
    FLAT_CONFIG_BACK = "flat_config_back",
    FLAT_CONFIG_MODAL = "flat_config_modal",
    FLAT_CONFIG_SIDEBAR = "flat_config_sidebar",
    FLAT_CONFIG_CONSTRUCTION_END_DATE = "flat_config_construction_end_date",
    FLAT_CONFIG_PRICE = "flat_config_price"
}

export enum PreferencesAction {
    LOCALISATION = "localisation",
    ROOMS_ADD = "rooms_add",
    ROOMS_DELETE = "rooms_delete",
    ROOMS_NUMBER = "rooms_number",
    FLAT_SIZE = "flat_size",
    FLOOR = "floor",
    WORLD_DIRECTION = "world_direction",
    LIGHT = "light",
    CONSTRUCTION_END_DATE = "construction_end_date",
    PRICE = "price",
    LOAN = "loan",
    AFTERMARKET = "aftermarket",
    ADDITIONAL_SPACES = "additional_spaces",
    KITCHEN_TYPE = "kitchen_type"
}

export const propertyConfiguratorEvent = (event: GTMEvent, data: Record<string, string | number | boolean | null> = {}, eventSuffix?: "add" | "delete") => {
    const preferences_action = eventSuffix ? `${data.preferences_action}_${eventSuffix}` : data.preferences_action;
    hitGoogleTagManager({event, ...data, ...(preferences_action && {preferences_action})});
};

export const propertyConfiguratorAnalytics = {
    gtm: {
        propertyConfiguratorEvent
    }
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export enum GTMEvent {
    FLAT_CONFIG = "flat_config",
    FLAT_CONFIG_CHANGE = "flat_config_change",
    FLAT_CONFIG_MORE = "flat_config_more",
    FLAT_CONFIG_OFFER_CLICK = "flat_config_offer_click",
    FLAT_CONFIG_BACK = "flat_config_back",
    FLAT_CONFIG_MODAL = "flat_config_modal",
    FLAT_CONFIG_SIDEBAR = "flat_config_sidebar",
    FLAT_CONFIG_CONSTRUCTION_END_DATE = "flat_config_construction_end_date",
    FLAT_CONFIG_PRICE = "flat_config_price"
}

export enum PreferencesAction {
    LOCALISATION = "localisation",
    ROOMS_ADD = "rooms_add",
    ROOMS_DELETE = "rooms_delete",
    ROOMS_NUMBER = "rooms_number",
    FLAT_SIZE = "flat_size",
    FLOOR = "floor",
    WORLD_DIRECTION = "world_direction",
    LIGHT = "light",
    CONSTRUCTION_END_DATE = "construction_end_date",
    PRICE = "price",
    LOAN = "loan",
    AFTERMARKET = "aftermarket",
    ADDITIONAL_SPACES = "additional_spaces",
    KITCHEN_TYPE = "kitchen_type"
}

export const propertyConfiguratorEvent = (event: GTMEvent, data: Record<string, string | number | boolean | null> = {}, eventSuffix?: "add" | "delete") => {
    const preferences_action = eventSuffix ? `${data.preferences_action}_${eventSuffix}` : data.preferences_action;
    hitGoogleTagManager({event, ...data, ...(preferences_action && {preferences_action})});
};

export const propertyConfiguratorAnalytics = {
    gtm: {
        propertyConfiguratorEvent
    }
};
